var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysTotalRoomsPerPeriod = function SvgSysTotalRoomsPerPeriod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.001 12.499v-1.39h-12v1.39a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 1 0v4.385h5.552v-2.41a1.187 1.187 0 0 1 1.095-1.262h1.029v.006h2.247a3.331 3.331 0 0 1 3.02 3.04.5.5 0 0 1 .06.24v5a.5.5 0 0 1-1 0l-.003.001Zm0-2.39v-1.22H2.003v1.223L14 10.108Zm-.01-2.223c-.047-1.48-.957-2.662-2.071-2.662H8.654a.309.309 0 0 0-.1.252v2.41h5.437ZM3.502 5.33a1.832 1.832 0 0 1 3.13-1.293 1.83 1.83 0 0 1-1.297 3.127 1.83 1.83 0 0 1-1.833-1.832v-.002Zm1 0a.84.84 0 0 0 .514.772.833.833 0 1 0-.514-.77v-.002Z"
  })));
};
export default SvgSysTotalRoomsPerPeriod;